define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'submit':'.submit_action',
            'form': '#payment_form',
            'amount': '#amount',
            'totalBonus': '#total_bonus',
            'balance': '#balance',
            'withdrawableSymbol': '#withdrawable_symbol',
            'withdrawableAmount': '#withdrawable_amount',
            'accountNoSelect': '#mt4_account_no',
            'currencyAbbr': '#currency_abbr'
        },

        events:{
            'click @ui.submit' : 'submit',
            'keyup @ui.amount': function(e){
                // Prevent anything other than 1-9 and . to be written in the amount input.
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g,''));
            },
            'change @ui.accountNoSelect': function(e){
                this.updateFinancial();
            },
            'change @ui.currencyAbbr': function(e){
                this.updateFinancial();
            }
        },

        updateFinancial: function(){
            var that = this;
            $.ajax({
                url: '/rest_payout/get_financial_info',
                data:{
                    account_no: this.ui.accountNoSelect.val(),
                    currency: this.ui.currencyAbbr.val()
                },

                success: function(data, res){
                    that.ui.balance.html(data.currency_symbol+' '+data.balance);
                    that.ui.totalBonus.html(data.currency_symbol+' '+data.total_bonus);
                    that.ui.withdrawableSymbol.html(data.currency_symbol+' ');
                    that.ui.withdrawableAmount.html(data.withdrawable);
                },
                error: function(data, error){

                }
            })
        },

        submit: function(e) {
            if(e) e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this);

            this.form.set( formData);
            var errors = this.form.validate();

            // if(parseFloat(this.ui.amount.val()) > parseFloat(this.ui.withdrawableAmount.text().replace(new RegExp(',', 'g'), ''))){
            //     errors = _.extend({}, errors, {amount: "You can't withdraw more than you have available."});
            // }
            // if(0 >= parseFloat(this.ui.amount.val())){
            //     errors = _.extend({}, errors, {amount: "You can't withdraw 0."});
            // }

            var that = this;
            if(_.size(errors) < 1){
                this.form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});
